import { useLayoutEffect, useRef, type TextareaHTMLAttributes } from "react";

type Props = Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, "rows" | "value" | "onChange"> & {
  value: string;
  onChange: (value: string) => void;
};

/**
 * A text field that grows downwards while typing, so a long remark stays fully readable (as in the
 * prototype). Enter does not start a new line: a remark is one piece of text that simply wraps.
 */
export function GrowingTextarea({ value, onChange, className, ...rest }: Props) {
  const ref = useRef<HTMLTextAreaElement>(null);

  useLayoutEffect(() => {
    const element = ref.current;
    if (!element) return;
    element.style.height = "auto";
    element.style.height = `${String(element.scrollHeight + element.offsetHeight - element.clientHeight)}px`;
  }, [value]);

  return (
    <textarea
      {...rest}
      ref={ref}
      rows={1}
      className={`grow ${className ?? ""}`}
      value={value}
      onChange={(event) => {
        onChange(event.target.value.replace(/\r?\n/g, " "));
      }}
      onKeyDown={(event) => {
        if (event.key === "Enter") event.preventDefault();
      }}
    />
  );
}
